import axios from 'axios';
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import env from '../../config/env';
import { useUser } from '../../utils/hook/UserContext';

/* ---------- Petits composants de présentation ---------- */

function DocTile({ icon, title, url, onChange }) {
  const done = Boolean(url);
  return (
    <label className={`mc-prof-doc${done ? ' is-done' : ''}`}>
      <span className="mc-prof-doc-icon" aria-hidden="true">
        <i className={`bi bi-${done ? 'check2-circle' : icon}`}></i>
      </span>
      <span className="mc-prof-doc-body">
        <span className="mc-prof-doc-title">{title}</span>
        <span className="mc-prof-doc-status">
          {done ? 'Document ajouté · cliquer pour remplacer' : 'À fournir · cliquer pour ajouter'}
        </span>
      </span>
      {done && (
        <a
          className="mc-prof-doc-link"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          Voir
        </a>
      )}
      <input type="file" accept="image/*,application/pdf" onChange={onChange} />
    </label>
  );
}

function TextField({ id, label, type = 'text', value, onChange, placeholder, disabled }) {
  return (
    <div>
      <label className="mc-field-label" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className="mc-input"
        type={type}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
}

/* ---------- Composant ---------- */

function AcccountHostItem() {
  const [isHovered, setIsHovered] = useState(false);
  const [data, setData] = useState(null);
  const { user } = useUser();

  const [PermisConduire, setPermisConduire] = useState(data?.PermisConduire);
  const [PieceIdentite, setPieceIdentite] = useState(data?.PieceIdentite);
  const [ExpertVitesseManuelle, setExpertVitesseManuelle] = useState(data?.ExpertVitesseManuelle);
  const [FirstName, setFirstName] = useState(data?.firstName);
  const [lastName, setLastName] = useState(data?.lastName);
  const [dateNaissance, setDateNaissance] = useState(data?.dateNaissance);
  const [city, setCity] = useState(data?.city);
  const [country, setCountry] = useState(data?.country);
  const [immat, setImmat] = useState(data?.immatriculation);
  const [tvaNumber, setTvaNumber] = useState(data?.tvaNumber);
  const [phoneNumber, setPhoneNumber] = useState(data?.phoneNumber);
  const [ImmatriculationDoc, setImmatriculationDoc] = useState(data?.ImmatriculationDoc);
  const [PieceIdentiteDoc, setPieceIdentiteDoc] = useState(data?.PieceIdentityDoc);
  useEffect(() => {
    if (!user?.id) return;

    const fetchUser = async () => {
      try {
        const { data: d } = await axios.get(`${env.baseUrlApi}/api/users/searchbyid/${user.id}`);

        setData(d);
        setPermisConduire(d?.PermisConduire);
        setPieceIdentite(d?.PieceIdentite);
        setFirstName(d?.firstName);
        setLastName(d?.lastName);
        setDateNaissance(d?.dateNaissance);
        setCity(d?.city);
        setCountry(d?.country);
        setImmat(d?.immatriculation);
        setTvaNumber(d?.tvaNumber);
        setPhoneNumber(d?.phoneNumber);
        setExpertVitesseManuelle(d?.ExpertVitesseManuelle);
        setImmatriculationDoc(d?.ImmatriculationDoc);
        setPieceIdentiteDoc(d?.PieceIdentityDoc);
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };

    fetchUser();
  }, [user?.id]);

  const userId = data?.id;

  useEffect(() => {
    if (!userId) return;

    const saveDocs = async () => {
      try {
        await axios.put(`${env.baseUrlApi}/api/users/${userId}`, {
          ExpertVitesseManuelle: ExpertVitesseManuelle == 1 ? 1 : 0,
          ImmatriculationDoc: ImmatriculationDoc,
          PieceIdentityDoc: PieceIdentiteDoc,
        });
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };

    saveDocs();
  }, [userId, ExpertVitesseManuelle, ImmatriculationDoc, PieceIdentiteDoc]);

  function handleApprouver() {
    let Approuve = async () => {
      try {
        const responseOption = await axios.put(`${env.baseUrlApi}/api/users/` + data?.id, {
          firstName: FirstName,
          lastName: lastName,
          dateNaissance: dateNaissance,
          city: city,
          country: country,
          immatriculation: immat,
          phoneNumber: phoneNumber,
          tvaNumber: tvaNumber,
        });
        if (responseOption.data) {
          toast.success('Les infos personnels ont bien été mise à jour avec succèss.');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    Approuve();
  }
  /*
  function handleSupprimer() {
    let Supprimer = async () => {
      try {
        const responseOption = await axios.put(
          `${env.baseUrlApi}/api/vehicleAnnonces/` + data?.vehiculeAnnonceId,
          { status: "2" },
        );
        if (responseOption.data) {
          toast.success("L'utilisateur a été bien rejeté avec succès!");
        }
      } catch (error) {
        console.error("Erreur lors de la requête Axios :", error);
      }
    };
    Supprimer();
  } */

  function handleModifier() {
    setIsHovered(true);
  }

  function handleAnnuler() {
    setIsHovered(false);
  }

  const handleImageUpload = (event, setImage) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'r6s4af83');

    fetch('https://api.cloudinary.com/v1_1/dtrkcpsky/image/upload', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => setImage(data.secure_url))
      .catch((error) => console.error('Error uploading image to Cloudinary:', error));
  };

  return (
    <>
      <ToastContainer />

      <div className="mc-prof-stack">
        {/* ── Documents ── */}
        <section className="mc-form-card mc-prof-card" aria-labelledby="prof-docs-title">
          <header className="mc-prof-card-head">
            <div>
              <h2 className="mc-prof-card-title" id="prof-docs-title">
                Documents
              </h2>
              <p className="mc-prof-card-desc">
                Ajoutés automatiquement à votre compte dès l'envoi.
              </p>
            </div>
          </header>
          <div className="mc-prof-docs">
            <DocTile
              icon="file-earmark-text"
              title="Certificat d'immatriculation"
              url={ImmatriculationDoc}
              onChange={(event) => handleImageUpload(event, setImmatriculationDoc)}
            />
            <DocTile
              icon="person-vcard"
              title="Pièce d'identité"
              url={PieceIdentiteDoc}
              onChange={(event) => handleImageUpload(event, setPieceIdentiteDoc)}
            />
          </div>
        </section>

        {/* ── Informations personnelles ── */}
        <section className="mc-form-card mc-prof-card" aria-labelledby="prof-info-title">
          <header className="mc-prof-card-head">
            <div>
              <h2 className="mc-prof-card-title" id="prof-info-title">
                Informations personnelles
              </h2>
              {isHovered && <span className="mc-prof-badge">Mode modification</span>}
            </div>
            <div className="mc-prof-actions">
              {isHovered ? (
                <>
                  <button
                    type="button"
                    className="mc-btn mc-btn--ghost mc-btn--sm"
                    onClick={handleAnnuler}
                  >
                    Annuler
                  </button>
                  <button
                    type="button"
                    className="mc-btn mc-btn--primary mc-btn--sm"
                    onClick={handleApprouver}
                  >
                    Enregistrer
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  className="mc-btn mc-btn--secondary mc-btn--sm"
                  onClick={handleModifier}
                >
                  <i className="bi bi-pencil" aria-hidden="true"></i>
                  Modifier
                </button>
              )}
            </div>
          </header>

          <div className="mc-prof-group">
            <h3 className="mc-prof-group-title">Identité</h3>
            <div className="mc-prof-fields">
              <TextField
                id="prof-firstname"
                label="Prénom"
                value={FirstName}
                onChange={setFirstName}
                disabled={!isHovered}
              />
              <TextField
                id="prof-lastname"
                label="Nom"
                value={lastName}
                onChange={setLastName}
                placeholder="Nom de famille"
                disabled={!isHovered}
              />
              <TextField
                id="prof-birth"
                label="Date de naissance"
                type="date"
                value={dateNaissance?.substring(0, 10)}
                onChange={setDateNaissance}
                disabled={!isHovered}
              />
              <TextField
                id="prof-phone"
                label="Numéro de téléphone"
                type="tel"
                value={phoneNumber}
                onChange={setPhoneNumber}
                placeholder="+33 6 56 67 89 00"
                disabled={!isHovered}
              />
            </div>
          </div>

          <div className="mc-prof-group">
            <h3 className="mc-prof-group-title">Localisation</h3>
            <div className="mc-prof-fields">
              <TextField
                id="prof-city"
                label="Ville"
                value={city}
                onChange={setCity}
                disabled={!isHovered}
              />
              <TextField
                id="prof-country"
                label="Pays"
                value={country}
                onChange={setCountry}
                placeholder="Pays de résidence"
                disabled={!isHovered}
              />
            </div>
          </div>

          <div className="mc-prof-group">
            <h3 className="mc-prof-group-title">Véhicule et fiscalité</h3>
            <div className="mc-prof-fields">
              <TextField
                id="prof-immat"
                label="Immatriculation"
                value={immat}
                onChange={setImmat}
                placeholder="Immatriculation"
                disabled={!isHovered}
              />
              <TextField
                id="prof-tva"
                label="Numéro TVA"
                value={tvaNumber}
                onChange={setTvaNumber}
                placeholder="456008"
                disabled={!isHovered}
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AcccountHostItem;
